// extracted by mini-css-extract-plugin
export default {"icon":"Spinner_icon__h2hGt","spinner":"Spinner_spinner__ZF7qS","spin":"Spinner_spin__kO-h5"};